export function formatNumber(number: number | Array<number>, num_decimals?: number, include_comma?: boolean) {
  if (typeof number !== "number" && number.length > 0) {
    number = number[0];
  }

  return number.toLocaleString("en-US", {
    useGrouping: include_comma,
    minimumFractionDigits: num_decimals,
    maximumFractionDigits: num_decimals,
  });
}

export function formatWholeDollars(amount: number): string {
  return amount.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
}

export function formatMoneyAmount(cost: string): string {
  const num = parseFloat(cost);
  if (isNaN(num)) return cost;
  return num % 1 === 0 ? `$${num.toFixed(0)}` : `$${num.toFixed(2)}`;
}
